import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { apiSlice } from "core/src/store/rtk-instance";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlImport } from "etl/types";
import { TriggerFiltersTagsEnum } from "../../triggerFilters.endpoints";

export interface UploadCompetitorFileRequest {
	formData: FormData
	fileName: string
	laboratoryId?: string
}

export const uploadCompetitorFile = createAppAsyncThunk<EtlImport | unknown, UploadCompetitorFileRequest>(
	"formStep/uploadCompetitorFile",
	async (data, { extra, getState, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;

			if (!selectedEtlImportUuid) return rejectWithValue("Aucun import sélectionné");

			const res = await extra.etlClient.uploadFile(selectedEtlImportUuid, data);

			dispatch(postToast({ message: "Fichier téléversé avec succès", type: ToastType.SUCCESS }));
			dispatch(apiSlice.util.invalidateTags([TriggerFiltersTagsEnum.FILE_COMPETITOR_UPLOADED_STATUS]));

			

			return res;
		} catch (error: unknown) {
			dispatch(displayApiErrorToast(error.response));
			return rejectWithValue(error.response.data.message);
		}
	}
);
